import { ScriptMap } from "@market/lib";
import { storeUtils, toProxy } from "../../../../libs/fanfanlo";


interface LibIndexInfo {
    list: string[];
}
const libIndexInfo = storeUtils.createLocalStore<LibIndexInfo>('markets-script-index-info', { defData: { list: [] }, forceReset: false });
export const lib = toProxy<ScriptMap>({});

let isInitialized = false;
function init(){
    if(isInitialized){
        return;
    }
    isInitialized = true;
}
export const marketsScriptLib = {
    lib,
    libIndexInfo,
    init
}